import { createContext, useContext } from 'react';

type SelectTabContextProps = {
	selectedTab: string;
	setSelectedTab: (o: string) => void;
};

const SelectTab = createContext<SelectTabContextProps>({} as SelectTabContextProps);

type SelectTabProps = {
	children: React.ReactNode;
	selectedTab: string;
	setSelectedTab: (o: string) => void;
};

const useProvideSelectTab = (selectedTab: string, setSelectedTab: (o: string) => void) => {
	return {
		selectedTab,
		setSelectedTab,
	};
};

const SelectTabProvider = ({ children, selectedTab, setSelectedTab }: SelectTabProps) => {
	const toggle = useProvideSelectTab(selectedTab, setSelectedTab);

	return <SelectTab.Provider value={toggle}>{children}</SelectTab.Provider>;
};

export const useSelectTab = () => useContext(SelectTab);

export default SelectTabProvider;
